import { createContext, useContext } from 'react';
import { SIZE } from './constants';
export const CardContext = createContext({
    size: SIZE.M,
    disabled: false,
});
export function useCardContext() {
    return useContext(CardContext);
}
export const FunctionBadgeContext = createContext({
    visible: false,
    setVisible: () => { },
});
